module.exports = __webpack_public_path__ + "img/freestyleImgText.dc807c5b.png";